/* eslint-disable react/prop-types */
import React from 'react';

import AmChart from './amchart.jsx';

import 'amcharts3/amcharts/pie';
import reportErrors from 'components/charts/reportErrors.jsx';

let PieChart = ({data, titleField = 'name', valueField = 'value', colorField = 'color', height,
                  legend = false, balloonText = undefined, innerRadius = undefined}) => {
  let config = {
    colorField: colorField,
    dataProvider: data,
    labelsEnabled: false,
    startDuration: 0,
    theme: 'light',
    titleField: titleField,
    type: 'pie',
    valueField: valueField,
    innerRadius: innerRadius,
    balloonText: balloonText,
  };

  if (legend) {
    config.legend = {
      position: 'top',
    };
  }
  return <AmChart height={height} config={config} />;
};

export default reportErrors(PieChart);
